import {
    ENGAGEMENT_CHAT_ATTACHMENT_ACCEPT,
    MAX_ENGAGEMENT_CHAT_ATTACHMENTS,
    type EngagementChatAttachmentCandidate,
    type EngagementChatAttachmentValidationFailure,
    validateEngagementChatAttachmentFiles,
} from '@houzy/schemas/partner-cockpit/chat';

export {
    ENGAGEMENT_CHAT_ATTACHMENT_ACCEPT,
    MAX_ENGAGEMENT_CHAT_ATTACHMENTS,
    type EngagementChatAttachmentValidationFailure,
    validateEngagementChatAttachmentFiles,
};

export function engagementChatAttachmentValidationMessageKey(
    failure: EngagementChatAttachmentValidationFailure,
): string {
    switch (failure.reason) {
        case 'too_many':
            return 'OFFER_REQUESTS.CHAT.ERROR.UPLOAD_MAX_ATTACHMENTS';
        case 'too_large':
            return 'OFFER_REQUESTS.CHAT.ERROR.UPLOAD_TOO_LARGE';
        case 'unsupported_type':
            return 'OFFER_REQUESTS.CHAT.ERROR.UPLOAD_UNSUPPORTED_TYPE';
    }
}

export function engagementChatAttachmentValidationMessageParams(
    failure: EngagementChatAttachmentValidationFailure,
): Record<string, string | number> {
    switch (failure.reason) {
        case 'too_many':
            return { maxCount: failure.maxCount };
        case 'too_large':
            return { fileName: failure.fileName, maxSizeMb: failure.maxSizeMb };
        case 'unsupported_type':
            return { fileName: failure.fileName };
    }
}

export function matchAcceptedAttachmentFiles(
    files: readonly File[],
    accepted: readonly EngagementChatAttachmentCandidate[],
): File[] {
    const remaining = [...files];
    const matched: File[] = [];
    for (const candidate of accepted) {
        const index = remaining.findIndex((file) => file.name === candidate.name && file.size === candidate.size);
        if (index === -1) {
            continue;
        }
        const [file] = remaining.splice(index, 1);
        if (file !== undefined) {
            matched.push(file);
        }
    }
    return matched;
}
